import { StyledAccordion, StyledAccordionTitle } from 'components/CustomAccordion/CustomAccordion.styled'
import { StyledRibbon } from 'components/Ribbon/Ribbon.styled'
import styled, { css } from 'styled-components'
import { CustomAccordion } from 'components/CustomAccordion/CustomAccordion'
import { StickyProp } from 'layouts/Layout.styled'
import { gridBreakPoints } from 'common/theme'

export const StyledBuyerSearchHeader = styled.div``
export const StyledBuyerSearchAction = styled.div`
  padding-bottom: 2.5rem;
  border-bottom: 0.1rem solid #e5e5e5;
`
export const StyledSearchButton = styled.div`
  display: flex;
  justify-content: center;
  .btn-outline-secondary {
    color: #6c757d;
    border-color: #6c757d;
  }
  .btn-outline-secondary:hover {
    color: #fff;
    background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
  }
  .btn-outline-secondary:focus,
  .btn-outline-secondary.focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
  }
  .btn-outline-secondary.disabled,
  .btn-outline-secondary:disabled {
    color: #6c757d;
    background-color: transparent;
  }
  .btn-outline-secondary:not(:disabled):not(.disabled):active,
  .btn-outline-secondary:not(:disabled):not(.disabled).active,
  .show > .btn-outline-secondary.dropdown-toggle {
    color: #fff;
    background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
  }
  .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
  .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
  .show > .btn-outline-secondary.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
  }

  .btn-outline-primary {
    color: ${({ theme }) => theme.colors.defaultTextColor};
    border-color: ${({ theme }) => theme.colors.defaultTextColor};
  }
  .btn-outline-primary:hover {
    color: #fff;
    background-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
  }
  .btn-outline-primary:focus,
  .btn-outline-primary.focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
  }
  .btn-outline-primary.disabled,
  .btn-outline-primary:disabled {
    color: #6c757d;
    background-color: transparent;
  }
  .btn-outline-primary:not(:disabled):not(.disabled):active,
  .btn-outline-primary:not(:disabled):not(.disabled).active,
  .show > .btn-outline-primary.dropdown-toggle {
    color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
    background-color: #fff;
    border-color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
  }
  .btn-outline-primary:not(:disabled):not(.disabled):active:focus,
  .btn-outline-primary:not(:disabled):not(.disabled).active:focus,
  .show > .btn-outline-primary.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
  }
`
export const StyledBuyerSearchContent = styled.div`
  height: 100%;

  .see-more {
    font-size: 1.6rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.defaultTextColor};
    box-shadow: none;
  }

  .selected-filter-label {
    text-transform: uppercase;
    color: #999;
    display: block;
    padding-bottom: 0.2rem;
    padding-left: 1rem;
    border-top: none;
    background-color: #f8f8f8;
  }

  ${StyledAccordion} {
    &.selected-filter {
      border-color: #fff;
    }
  }
`
export const StyledMultiSelectFilterSection = styled.div<{ noOfCols?: number }>`
  display: flex;
  grid-template-columns: repeat(${({ noOfCols }) => noOfCols ?? 3}, 1fr);
  gap: 1rem;
  max-width: 100%;
  flex-wrap: wrap;

  .custom-control-label {
    width: 100%;
  }

  .vehicle-count {
    color: ${({ theme }) => theme.colors.InfinitiLinkColor};
  }
`
export const StyledRibbonLabel = styled.div`
  display: flex;
  gap: 2rem;
  width: 100%;

  ${StyledRibbon} {
    flex-grow: 2;

    .ribbon {
      width: 100%;
      text-align: center;

      .ribbon-title {
        filter: brightness(0.75);
      }
    }
  }
`
export const StyledSliderFilterSection = styled.div``
export const StyledCarfaxFilterItemContainer = styled.div`
  & + & {
    margin-top: 0.75rem;
  }
`
export const StyledCarfaxFilterItemHeader = styled.div`
  text-transform: uppercase;

  color: #999;
  display: block;
  margin-bottom: 0.5rem;
  padding-bottom: 0.2rem;
  border-bottom: 1px solid #ccc;
  border-top: none;
`
export const StyledCarfaxFilterItemContent = styled.div`
  margin-left: 5px;
`
export const StyledCarfaxAccordion = styled(CustomAccordion)`
  background-color: rgb(253, 251, 225);
  ${StyledAccordionTitle} img {
    width: 10rem;
  }
`

export const BUYER_SEARCH_OFFSET_HEIGHT = 60

export const StyledBuyerSearch = styled.div<StickyProp>`
  position: sticky;
  top: ${BUYER_SEARCH_OFFSET_HEIGHT}px;
  ${({ isSticky }) =>
    isSticky &&
    css`
      top: 50px;

      .header-toggle {
        display: none;
      }

      @media (min-width: ${gridBreakPoints.xl}) {
        top: 60px;
      }
    `}
`

export const StyledFilterSection = styled.div`
  max-height: calc(100vh - 28rem);
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar-thumb {
    background-color: #9e9a9acc;
  }

  ::-webkit-scrollbar {
    width: 0.4rem;
  }
`
